import { useState } from "react";
import { Order } from "../types/order";

type UseOrderDetailsToggle = {
  showOrderDetails: boolean;
  selectedOrder: Order | undefined;
  setOrder: (order: Order) => void;
  clearOrder: () => void;
};

export const useOrderDetailsToggle = (): UseOrderDetailsToggle => {
  const [showOrderDetails, setShowOrderDetails] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState<Order | undefined>(
    undefined,
  );

  const setOrder = (order: Order) => {
    setSelectedOrder(order);
    setShowOrderDetails(true);
  };

  const clearOrder = () => {
    setShowOrderDetails(false);
    setSelectedOrder(undefined);
  };

  return { showOrderDetails, selectedOrder, setOrder, clearOrder };
};
